import styled from "styled-components";
import { Button } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledSelectedFilterOption = styled(Button)`
    min-width: auto;
    padding: 8px 12px 8px 8px;

    font-size: var(--size-14);
    font-weight: normal;
    color: var(--color-grey-900);
    text-transform: none;
    white-space: nowrap;
    background: var(--color-secondary-light);
    border-radius: var(--radius-10);
    box-shadow: none;

    svg path {
        fill: var(--color-secondary);
    }

    &:hover {
        box-shadow: none;

        background: var(--color-secondary-light);
    }
    @media ${breakpoints.xs} {
        margin-top: 16px;
        margin-right: 16px;
        margin-left: 0;
    }
`;
